import { createSlice } from '@reduxjs/toolkit'

import { initialState } from 'store/pages/typeticketcollection/state'

import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'

export const TypeTicketCollectionSlice = createSlice({
  name: 'typeticketcollection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const typeticketcollection = action.payload
      state.typeticketcollections[action.meta.arg.id] = typeticketcollection
    })
    builder.addCase(getBulkData.fulfilled, (state, action) => {
      action.payload.forEach(
        (typeticketcollection) => (state.typeticketcollections[typeticketcollection.id] = typeticketcollection)
      )
    })
  },
})
